import { render } from "./project-created.vue?vue&type=template&id=6506659e"
import script from "./project-created.vue?vue&type=script&lang=js"
export * from "./project-created.vue?vue&type=script&lang=js"

import "./project-created.vue?vue&type=style&index=0&id=6506659e&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__